<template>
    <TheModal class="sm" @close="close">
        <template v-slot:head>IMEI {{ modem.imei }}</template>

        <p v-show="modem">
            <router-link :to="{ name: 'admin.company', params: { id: modem.company_id }}">{{ modem.company_name }}</router-link>
            <span v-if="modem.vm_id" class="ml-2">T{{ modem.vm_id }}</span>
        </p>

        <table v-show="modem.commands && modem.commands.length" class="table">
            <thead>
                <tr>
                    <th>Очередь команд на отправку</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                <tr v-for="(command, index) in modem.commands" :key="index">
                    <td colspan="2">{{ command.key }}={{ command.value }}</td>
                </tr>
            </tbody>
        </table>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
            <ValidationProvider v-errors.api vid="command" tag="div" class="form-group">
                <select-modem-command v-model="cc" class="form-control" />
            </ValidationProvider>

            <ValidationProvider v-errors.api vid="name" tag="div" class="form-group" rules="required|max:200">
                <textarea v-model="cc" class="form-control" />
            </ValidationProvider>

            <div>
                <button type="submit" class="btn btn-primary btn-lg">Отправить</button>
            </div>
        </ValidationObserver>
    </TheModal>
</template>

<script>
import axios from 'axios'

import SelectModemCommand from '@/components/SelectModemCommand'
import TheModal from '@/components/TheModal'

import { ValidationProvider, ValidationObserver } from 'vee-validate'

import { toastSuccess, toastError } from '@/dialogs'

export default {
    components: {
        SelectModemCommand,
        TheModal,
        ValidationObserver,
        ValidationProvider
    },

    data() {
        return {
            modem: {},
            cc: null
        }
    },

    methods: {
        close() {
            this.$router.push({ name: 'admin.modems' })
        },

        async submit() {
            try {
                const response = await axios.post(`api/admin/modems/${this.modem.id}/commands`, {
                    cc: this.cc
                })

                if (response.data.length > 0) {
                    toastSuccess('Команда добавлена в очередь')
                    this.modem.commands.push(...response.data)
                    this.cc = null

                    this.$refs.obs.reset()
                } else {
                    toastError('Не удалось дабавить команду в очередь отправки')
                }
            } catch (error) {
                toastError('Не удалось дабавить команду в очередь отправки')
            }
        }
    },

    async beforeRouteEnter(to, from, next) {
        if (!to.params.id) {
            return next({ name: 'admin.modems' })
        }

        try {
            const response = await axios.get(`api/admin/modems/${to.params.id}`)

            return next(vm => { vm.modem = response.data })
        } catch (error) {
            return next({ name: 'admin.modems' })
        }
    }
}
</script>
